module.exports = __webpack_public_path__ + "img/hk.71a18b72.png";